<template>
  <div class="top">
    <p
      class="title"
      :style="{
        'font-weight': '700',
        'line-height': '42px',
        color: '#0F1734',
      }"
    >
      Muted Users
    </p>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div v-if="!loading && mutedUsers.length > 0">
      <div style="margin-top: 48px; margin-bottom: 24px; display: flex; justify-content: space-between;">
        <p class="result-length">{{ mutedUsers.length }} Results</p>
      </div>
      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-3 position-relative" v-for="user in mutedUsers" :key="user.id">
        <div class="claim-card">
          <div class="user-name d-flex  p-3">
            <a class="bg-img d-block background-image mr-3" @click="viewProfile(user)">
              <a-avatar
                :style="{
                  color: ' #ffffff !important',
                  'background-color': user.url ? user.url : '' ? '' : '#C997C5',
                }"
                :size="70"
                :src="user.url"
                class="text-capitalize"
              >
                {{ user.firstName ? user.firstName[0] : user.display_name ? user.display_name[0] : user.first_name[0] }}
              </a-avatar>
            </a>
            <div class="divider" />
            <div class="right-items profile-btn">
              <div class="d-inline-block text-left ml-2 align-self-center">
                <p
                  class=" bold-text cp"
                  @click="viewProfile(user)"
                  :style="{
                    color: '#0F1734',
                    'font-weight': '700',
                    'font-size': '20px',
                    'line-height': '30px',
                    'margin-bottom': '4.5px',
                  }"
                >
                  {{ user.display_name }}
                </p>
                <p :style="{ color: '#94A3B8', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px' }" v-if="user.location && user.location[0].state" class="m-0 doc-loc text-truncate">
                  <img src="../../../assets/images/addphy-location.png" />
                  {{ user.location[0].city }},
                  {{ user.location[0].state }}
                </p>
                <p
                  :style="{
                    color: '#0F1734',
                    'font-size': '14px',
                    'line-height': '21px',
                    'font-weight': 'bold',
                    'margin-top': '4.5px',
                  }"
                >
                  {{ user.circle_member ? user.circle_member : 0 }} circle members
                </p>
              </div>
              <div class="meet-others">
                <a-button
                  :style="{
                    background: getPrimaryColor(),
                    'pointer-events': 'all',
                    'font-size': '14px',
                    'border-radius': '6px',
                    padding: '12px 24px',
                    'justify-content': 'center',
                  }"
                  class=" font-white primary-button profile-btn"
                  :loading="activeUser === user.id ? isPageRouting : false"
                  @click="UnMuteUser(user)"
                >
                  Unmute
                </a-button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="user.id === profileLoading" class="spinnerContainer-post">
          <a-spin size="large" />
        </div>
      </div>
    </div>
    <div v-if="!loading && mutedUsers.length === 0">
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">
            You have not muted any users yet.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientMutedUser",
  components: {},

  data() {
    return {
      profileLoading: null,
      mutedUsers: [],
      id: null,
      activeUser: 0,
      loading: true,
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    viewProfile(user) {
      this.profileLoading = user.id
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
              case "physician":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.id },
                })
                break
              case "hcp":
              case "ohcp":
              case "ahcp":
              case "other":
                this.$router.push({
                  name: "ViewHcpUpdates",
                  params: { id: user.id },
                })
                break
              case "clinic_administrator":
                this.$router.push({
                  name: "ViewClinicAbout",
                  params: { id: user.id },
                })
                break
              case "hospital_administrator":
                this.$router.push({
                  name: "ViewHos_adminAbout",
                  params: { id: user.id },
                })
                break
              case "nfp":
                this.$router.push({
                  name: "ViewNfpAbout",
                  params: { id: user.id },
                })
                break
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id, role: "caregiver" },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateAbout",
                  params: { id: user.id },
                })
                break
              case "hospital":
                this.$router.push({
                  name: "HospViewAbout",
                  params: { id: user.id },
                })
                break
              case "clinic":
                this.$router.push({
                  name: "ClinicViewAbout",
                  params: { id: user.id },
                })
              case "nfp_administrator":
                this.$router.push({
                  name: "ViewNfpAdminAbout",
                  params: { id: user.id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {
            this.profileLoading = null
          })
      }
    },
    fetch(append = false) {
      this.loading = true
      UserRepository.getMutedUsers(this.currentCircle.id)
        .then(res => {
          if (append) {
            this.mutedUsers.push(...res.data.data.data)
            this.currentPage += 1
          } else {
            if (res.data) {
              this.mutedUsers = res.data.data
              this.loading = false
              // this.pagination = res.data.data.paginator;
            }
          }
          console.log(this.mutedUsers, "muted users")
        })
        .catch(err => {})
    },

    UnMuteUser(user) {
      UserRepository.UnmuteUser({ user_circle: this.currentCircle.id, user_id: user.id, mute: false, role: user.role })
        .then(res => {
          this.$notification.success({
            message: "Unmuted",
            description: "This user has been unmuted successfully",
          })
          this.fetch()
        })
        .catch(e => {
          this.$notification.error({
            message: "Error",
            description: "Cannot mute user",
          })
        })
    },
  },
}
</script>

<style lang="scss">
.viewmore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;
}

.loc-text-cont {
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.close-icon {
  // position:absolute;
  // left:-150px;
  // top:130px;
  margin-left: 85px !important;
  cursor: pointer;
}

.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
  border: none;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important ;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>

<style lang="scss" scoped>
.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}

.result-length {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}
.title {
  font-size: 32px;
  @media screen and (max-width: 700px) {
    font-size: 24px;
  }
}
.top {
  width: 100%;
}

@media screen and (max-width: 750px) {
  .right-items {
    p {
      margin-bottom: 1rem !important;
      margin-top: 0px !important;
    }
  }
}
.profileBtn {
  color: #fff;
}

.location-text {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
}
.result {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}
.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  width: 792px;
  height: 36px;
}
.a-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 790px;
}

.search-container {
  display: flex;
  gap: 24px;
}

.btn-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0px;

  width: 126px;
  height: 111px;
}

.btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 126px;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

.members {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  height: 22px;
  background: #e1eaf7;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #2a71d4;
}

.name {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
  cursor: pointer;
}

.loc {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 451px;
  height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
}

.info-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 451px;
  height: 121px;
}

.image {
  width: 70px;
  height: 70px;
  border-radius: 5rem;
}
.line {
  width: 0px;
  background-color: #0f1734;
  height: 100%;
}
.profile-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 93px;
  height: 70px;
  cursor: pointer;
}
.cards {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  width: 790px;
  height: 159px;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.filter-icon {
  width: 24px;
  height: 24px;
}
.filter {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 24px;
  width: 636px;
  height: 38px;
  border-radius: 6px;
  flex: none;
  order: 1;
  flex-grow: 1;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  text-decoration-line: underline;
  color: #0f1734;
  cursor: pointer;
}

.third-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 24px;

  width: 742px;
  height: 38px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
}

.display-flex-row-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.invite-others {
  padding: 8px 0px;
  gap: 4px;
  width: 82px;
  height: 30px;
  border-radius: 6px;
  flex: none;
  order: 0;
  flex-grow: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #2a71d4;
}

.search-btn {
  padding: 8px;
  gap: 16px;
  width: 60px;
  height: 60px;
  background: #f1f5f9;
  border-radius: 8px;
  flex: none;
  order: 1;
  flex-grow: 0;
  color: #0f1734;
  border: none;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

input[type="search"]::placeholder {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}

input:focus {
  border: none;
  outline: none;
}

form.nosubmit {
  border: none;
  padding: 0;
}

input:active {
  border: none;
  outline: none;
}
// input.nosubmit {
//   position: relative;
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   padding: 4px 4px 4px 48px;
//   gap: 8px;
//   width: 658px;
//   height: 60px;
//   background: #F1F5F9;
//   border-radius: 8px;
//   background-image:url("../../assets/images/search-icon.png") ;
//   background-repeat: no-repeat;
//   background-position: 18px;
//   font-weight: 700;
//   font-size: 16px;
//   line-height: 32px;
//   border:none;
// }

////
.meet-all {
  width: 100%;
  max-width: 400px;
  margin: auto;
  display: flex;
  justify-content: center;
  button {
    width: 50% !important;
    margin: 0;
  }
}
.filter-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;

  input {
    border: none !important;
  }
}

.card-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 56px;
}
.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
  height: 60px;
}
.search-button {
  width: 100%;
  background: #f1f5f9;
  border: none;
}
.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: context-menu;
}

.dovemed-card {
  .meet-all {
    .dovemed-button-left {
      font-weight: bold;
      border-top-left-radius: 15 !important;
      border-bottom-left-radius: 15 !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    .dovemed-button-right {
      font-weight: bold;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
      border-top-right-radius: 15 !important;
      border-bottom-right-radius: 15 !important;
    }
  }
}

.text-mob {
  display: none;
  @media screen and (max-width: 750px) {
    display: flex;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #0f1734;
  }
}
.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;
  @media screen and (max-width: 750px) {
    flex-direction: column;
  }

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 32px;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 60px;
    min-width: 60px;
    border-radius: 8px;
    height: 60px;
    @media screen and (max-width: 750px) {
      max-width: 100%;
      width: 100%;
    }
    &:focus {
      outline: none;
    }
  }
}

.dovemed-button {
  padding: 12px 45px;
}

// STYLES MEETPEOPLE
.meet-others {
  display: flex;
  align-items: center;
  button {
    display: flex;
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    @media screen and (max-width: 600px) {
      width: 100%;
      justify-content: center;
    }
  }
  span {
    font-size: 14px !important;
  }
}
.results {
  font-size: 20px;
  color: #0f1734;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
}
.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
}
.signup-page {
  padding: 70px;
}
.divider {
  height: 159px;
  border: 1px solid #cbd5e1;
  margin-top: -16px;
  background: #cbd5e1;
  margin-left: 37.5px;
  @media screen and (max-width: 600px) {
    height: inherit !important;
    left: 80px;
    position: absolute;
  }
}
.search-container {
  display: flex;
  @media screen and (max-width: 750px) {
    flex-direction: column;
  }

  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    width: 95%;

    &:focus {
      outline: none;
    }
  }
  display: flex;
  align-items: center;
  .search-input-state {
    border-left: 0 !important;
    padding: 10px;
    width: 320px;

    &:focus {
      outline: none;
    }
  }
  .dropdownOptions {
    margin-right: 154px;
  }

  .search-button {
    max-width: 100px;
    padding: 11px;

    @media screen and (max-width: 900px) {
      padding: 6px;
    }
    @media screen and (max-width: 750px) {
      max-width: 100%;
      width: 100%;
    }

    &:focus {
      outline: none;
    }
  }
}

.input-placeholder {
  min-width: unset;

  &.male {
    border-radius: 20px 0 0 20px;
  }

  &.female {
    border-radius: 0 0 0 0;
    margin-left: -5px;
  }
  &.other {
    border-radius: 0 20px 20px 0;
    margin-left: -5px;
  }
}

.claim-card {
  border: 1px solid #e2e8f0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  .user-name {
    height: 159px;
    @media screen and (max-width: 600px) {
      height: 100% !important;
    }
    .bg-img {
      position: relative;
      // border: 1px solid #ccc;
      // min-width: 100px;
      max-width: 100px;
      min-height: 100px;
      max-height: 100px;
      border-radius: 50%;
      display: inline-block;
      margin-top: 24px;
      margin-left: 35.5px;
      @media screen and (max-width: 600px) {
        margin-left: 0 !important;
      }

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.claim-modal-header {
  border-radius: 5px 5px 0 0;
  min-height: 100px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;

  .profile-img {
    min-width: 150px;
    max-width: 150px;
    min-height: 150px;
    max-height: 150px;
    display: block;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.4);
  }
}

.profile-details {
  padding-top: 170px;
  max-width: 60%;
  margin: auto;
}

.terms-modal-container {
  padding: 30px;
  text-align: center;
}

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.filters-cont {
  transition: height 0.3s ease-in-out;
}

.transparent {
  opacity: 0;
  display: none;
}

.no-results-container {
  background: rgb(246, 246, 246);
  padding: 20px;
  border-radius: 8px;
}
@media screen and (max-width: 581px) {
  .search-input-state {
    width: 100%;
  }
  .filters-cont {
    .filter-content {
      display: flex;
      flex-direction: column;
    }
    .input-placeholder {
      padding: 8px 8px;
    }
  }
}
.clear-filter {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  text-decoration-line: underline;
  margin-top: 28px;
  margin-right: 28px;
}
.right-items {
  display: flex;
  width: 100%;
  justify-content: space-between;
  overflow: none !important;
  margin-left: 24px;

  // @media screen and (max-width: 900px) {
  //   display: block;
  //   margin-left: 16px;
  // }

  @media screen and (max-width: 600px) {
    display: block;
    margin-left: 16px;
  }
}
.spinnerContainer-post {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/PatientMutedUser.vue